// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

import { langdetector } from '@/langdetector';

//SET IDIOMA
localStorage.setItem('language', 'es');

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = process.env.VUE_APP_BACK;
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';

Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE


//IDIOMAS
import VueI18n from 'vue-i18n'
import * as jsonmessages from './translations/translations.json';


axios.get('/dmb_extra/json_translation.json').then(result => {
	let jsonmessages = result.data;
	jsonmessages.es.enlaces = jsonmessages.enlaces;
	setApp(jsonmessages);
}).catch(error => {
	setApp(jsonmessages);
});

function setApp(messages) {
	Vue.use(VueI18n);

	const i18n = new VueI18n({
		locale: store.state.language,
		messages: messages,
	});
	//.IDIOMAS

	Vue.config.productionTip = false

	new Vue({
		el: '#app',
		router,
		i18n,
		store,
		VeeValidate,
		components: { App },
		template: '<App/>'
	})
}




// WEBPACK FOOTER //
// ./src/main.js